"use client";

import { Button } from "@/components/ui/button";
import { Send, Search, Zap, BarChart3, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Discovery & Alignment",
  description: "We assess priorities, technology landscape, risk posture, and AI maturity to establish a clear strategic foundation.",
  icon: Search
}, {
  title: "Strategic Design",
  description: "We define governance models, roadmap sequencing, and executive oversight structures aligned with measurable business outcomes.",
  icon: Zap
}, {
  title: "Structured Execution Oversight",
  description: "We guide implementation with vendor‑neutral oversight to ensure alignment, accountability, and measurable ROI.",
  icon: BarChart3
}, {
  title: "Optimization & Scale",
  description: "We monitor performance and governance adherence to support sustainable scaling and long‑term value protection.",
  icon: ShieldCheck
}];
export default function StartAConversation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="start-a-conversation" ref={ref} className="relative min-h-screen dark-section bg-dark-background py-24 px-4 overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[length:24px_24px]"></div>

      <div className="relative max-w-5xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
            How We Work
          </h2>
          <p className="text-foreground-dark/70 text-lg max-w-2xl mx-auto">
            A structured path from strategy to scale — built for executive
            visibility and control.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {steps.map((step, i) => <div key={i} data-index={i} className={`card glass-effect p-6 flex flex-col items-start text-left transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <div className="mb-4 p-3 rounded-sm bg-primary/10 text-foreground-primary">
                <step.icon className="size-6" />
              </div>
              <h3 className="text-xl font-display font-bold text-foreground mb-2">
                {step.title}
              </h3>
              <p className="text-foreground-dark/60 text-sm leading-relaxed">
                {step.description}
              </p>
            </div>)}
        </div>

        <div className={`glass-effect p-12 rounded-md shadow-strong text-center transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: "500ms"
      }}>
          <Button size="lg" className="uppercase tracking-wider font-display font-bold px-7 py-3 rounded-sm bg-primary hover:bg-primary-hover active:bg-primary-active transition-colors">
            requested executive consultation
          </Button>
        </div>
      </div>
    </section>;
}